import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import DefaultAvatar from '../../assets/icons/svgIcons/avatar.svg';
import ChooseImage from '../../assets/img/chooseImage.png';

const AvatarReco = (props) => {
  const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1)
      }
    },
    size: {
      width: theme.spacing(props.size),
      height: theme.spacing(props.size)
    }
  }));

  const classes = useStyles();

  const setImage = () => {
    const defaultPic = props.chooseImage ? ChooseImage : DefaultAvatar;
    return props.avatar?.thumbnail || props.avatar || defaultPic;
  };

  return (
    <>
      {props.avatar !== null ? (
        <Avatar
          onClick={props.onClick}
          className={classes.size}
          src={setImage()}
        />
      ) : (
        <Avatar className={classes.size} />
      )}
    </>
  );
};

AvatarReco.propTypes = {
  avatar: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  size: PropTypes.number,
  chooseImage: PropTypes.bool,
  onClick: PropTypes.func
};

export default AvatarReco;
